export enum limit {
    ORDER_SERVICE_ADD_IMAGE_MAX_SIZE = 5, // 订单处理 添加图片 最大大小MB
    ORDER_SERVICE_ADD_IMAGE = 4, // 订单处理 添加图片 最大限制
    ORDER_SERVICE_ADD_VIDEO_MAX_SIZE = 20, // 订单处理 添加图片 最大大小MB
    ORDER_SERVICE_ADD_VIDEO = 2, // 订单处理 添加视频 最大限制
    ORDER_SERVICE_ADD_TAG= 3, // 订单处理 添加标签 最大限制
  }
